import React from "react";
import "./styles.scss";
import Cart from "../../assets/images/Group3248.svg";
import { Col } from "react-bootstrap";

function Card({ heading, text, img }) {
  return (
    <div className="Card" style={{ cursor: "context-menu" }}>
      <img src={img} alt="icon" />
      <div className="Card_heading">{heading}</div>
      <div className="Card_txt">{text}</div>
    </div>
  );
}

export default Card;
